import React, { useState } from 'react'
import {
  H2,
  OrangeCircle,
  Button,
  TabFooter,
  Flex,
  Animation,
  SpecificationWrapper,
  ButtonsContainer,
  Separator,
  TerminateContractButton,
  ThinSeparator,
  ItemsGrid,
} from '../../styling/GlobalStyles'
import nationalities from './nationalities.json'
import {
  InputContainer,
  AddProfileImage,
  AddProfileImageClick,
  AddProfileImageInput,
} from './AddEmployee.styled'
import { Input } from '../../components/Input/Input'
import { addImagePlus } from '../../assets/icons/AddImagePlus'
import { formatDateForDisplay, getBase64, onlyLetters } from '../../utils/helpers'
import { HonestSelectInput } from '../../components/HonestSelect/HonestSelectInput'
import { accessTypeList, documentAccessRestrictionsOptions, documentCategoryOptions, genderList, maritalStatus } from './constants'
import Avatar from '../../assets/images/profileAvatar.png'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { ISelectValue } from 'constants/globalTypes'
import { validateSelect, standardFieldValidation, validateDate } from 'utils/validationUtils'
import { toast } from 'react-toastify'
import { CancelBtn } from 'components/Button/CancelBtn'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { IEmployee, IEmployeesTabWithValidation } from 'types/users.interface'
import { educationLevelOptions, emergencyContactOptions } from './employeesData'
import { BodyText, TitleText } from 'styling/Typography'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { AppDispatch, RootState } from 'store'
import { useDispatch, useSelector } from 'react-redux'
import { ToggleButton } from 'components/Input/ToggleButton'
import { requestNewTemporaryPassword } from 'features/user/userSlice'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { TerminateContractModal } from './TerminateContractModal'
import { createPortal } from 'react-dom'
import { DropZone } from 'components/DropZone/DropZone'
import { dietaryPreferences } from 'pages/Food/foodData'
import { SmallTable, SmallThead } from 'components/SmallTable/SmallTable.styled'

export const EmployeeBasicInfoTab = ({
  handleSubmit,
  state,
  setState,
  invalidFields,
  setInvalidFields,
}: IEmployeesTabWithValidation) => {
  const isEditing = location.pathname.includes('edit')
  const nationalitiesList = nationalities.sort((a, b) => a.label.localeCompare(b.label))
  const { user } = useSelector((state: RootState) => state.user)
  const { singleUser } = useSelector((state: RootState) => state.users)
  const dispatch = useDispatch<AppDispatch>()
  const [modal, setModal] = useState(false)

  useFocusFirstInput()

  const handleEmergency = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setState((prev: IEmployee) => {
      const copy = structuredClone(prev)
      copy.emergencyContact[name] = value
      return copy
    })
  }


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const name = (e.target as HTMLInputElement).name.split('-')
    const { value } = e.target as HTMLInputElement
    if (!['secondaryPhoneNumber', 'email'].includes(name[1])) {
      standardFieldValidation(e, setInvalidFields)
    }
    if (name[0] === 'contact') {
      setState((prev: IEmployee) => {
        if (prev.contact) {
          const copy = structuredClone(prev)
          copy.contact[name[1]] = value
          return copy
        }
      })
    } else {
      setState({ ...state, [(e.target as HTMLInputElement).name]: value })
    }
  }

  const handleDateChange = (value: Date, name: string) => {
    validateDate(name, setInvalidFields)

    setState({ ...state, [name]: value })

  }


  const handleReactSelect = (value, name: string) => {

    if (name !== 'workplaceLocation') {
      validateSelect(value, name, setInvalidFields)
    }
    setState((prev: IEmployee) => {
      const copy = { ...prev }

      copy.isNone = value.label == 'multiNone'

      if (['role', 'workplaceLocation'].includes(name)) {
        copy[name] = { id: value.value, name: value.label }
      } else {
        if (['department', 'foodDietaryPreferenceType'].includes(name)) {
          copy[name] = value
          return copy
        }
        copy[name] = value.value
      }
      return copy
    })
  }

  const handleImage = (e) => {
    e.target.parentElement.children[1].click()
  }

  const parse = (data: any) => {
    return data.data.map((item: any) => ({ label: item.name, value: item.id }))
  }


  const handleSave = () => {
    try {
      if (invalidFields.length < 1) {
        handleSubmit()
      } else {
        toast.warn('All fields must be valid')
      }
    } catch (error) {
      console.log(error)
    }

  }

  const getDobYears = () => {
    const date = new Date()
    date.setFullYear(date.getFullYear() - 18)
    return date
  }

  const handleActivateUser = async () => {
    const resp = await dispatch(requestNewTemporaryPassword({ username: singleUser.username }))
    if (resp.meta.requestStatus == 'fulfilled') {
      toast.success('User account has been intiated successfully')
    }

  }

  const handleToggleActivateUser = () => {
    setState(prev => ({ ...prev, shouldSendTemporaryPassword: !prev.shouldSendTemporaryPassword }))
  }

  const handleDocumentSelect = (value: ISelectValue, name: string) => {
    setState({
      ...state,
      documentData: {
        ...state.documentData,
        [name]: value,
      },
    })
  }

  const handleDocumentDateChange = (date: Date, name: string) => {
    setState({
      ...state,
      documentData: {
        ...state.documentData,
        [name]: date,
      },
    })
  }


  return (
    <Animation>
      <SpecificationWrapper style={{ paddingBottom: '5rem' }} >
        <Flex gap='1rem' mediaQ>
          <Flex column center justcenter gap='1rem'>
            <AddProfileImage style={{ marginTop: '-15rem' }} >
              {state?.image ? (
                <>
                  <AddProfileImageClick onClick={handleImage}>
                    <OrangeCircle>
                      <img
                        src={state.image}
                        alt='profile-image'
                        onError={({ currentTarget }) => (currentTarget.src = Avatar)}
                      />
                    </OrangeCircle>
                    <H2 noUpperCase>Your Profile Image</H2>
                  </AddProfileImageClick>
                  <AddProfileImageInput
                    type='file'
                    name='imageupload'
                    accept='image/*'
                    onChange={(e) => {
                      getBase64(e.target.files[0]).then((res: string) =>
                        setState((prev) => {
                          const copy = { ...prev }
                          copy.image = res
                          return copy
                        }),
                      )
                    }}
                  />
                </>
              ) : (
                <>
                  <AddProfileImageClick onClick={handleImage}>
                    <OrangeCircle>{addImagePlus}</OrangeCircle>
                    <H2 noUpperCase>Add Profile Image</H2>
                  </AddProfileImageClick>
                  <AddProfileImageInput
                    type='file'
                    name='imageupload'
                    accept='image/*'
                    onChange={(e) => {
                      getBase64(e.target.files[0]).then((res: string) =>
                        setState((prev) => {
                          const copy = { ...prev }
                          copy.image = res
                          copy.profileImage = true
                          return copy
                        }),
                      )
                    }}
                  />
                </>
              )}
            </AddProfileImage>
            {isEditing ? (singleUser?.shouldShowActivateButton && <Button orange onClick={handleActivateUser} >Activate User</Button>) : <><ToggleButton
              start
              state={state.shouldSendTemporaryPassword}
              handleChange={handleToggleActivateUser}
              label='Activate User Account'
              between
            /></>}
            {isEditing ? (((singleUser?.state !== 3) && !state?.contractTerminationRequest) ? <TerminateContractButton onClick={() => setModal(true)} >
              <CloseIcon /> <BodyText>Terminate Contract</BodyText>
            </TerminateContractButton> : <TerminateContractButton requestExists >
              <BodyText>{singleUser?.contractTerminationRequest.status == 1 ? 'Contract Termination Initiated' : 'Contract Terminated'}</BodyText>
              <ThinSeparator />
              <Flex column gap='1rem' >
                <BodyText weight='bold' >{formatDateForDisplay(singleUser?.contractTerminationRequest?.terminationDate)}</BodyText>
                <BodyText>{singleUser?.contractTerminationRequest?.reason}</BodyText>
              </Flex>
            </TerminateContractButton>) : <></>}
          </Flex>

          <Flex column width='100%' >
            <InputContainer>
              <Input
                type='text'
                labelText='First Name'
                name='firstName'
                onChange={handleChange}
                value={state?.firstName}
                placeholder='Enter first name'
                invalid={invalidFields.includes('firstName') ? 'true' : ''}
                onKeyDown={onlyLetters}
                keyProp={1}
              />
              <Input
                type='text'
                labelText='Middle and Last Name'
                name='lastName'
                onChange={handleChange}
                value={state?.lastName}
                placeholder='Enter last name'
                invalid={invalidFields.includes('lastName') ? 'true' : ''}
                onKeyDown={onlyLetters}
                keyProp={2}
              />
              <Input
                type='text'
                labelText='Username'
                name='username'
                onChange={handleChange}
                value={state?.username}
                placeholder='Enter username'
                invalid={invalidFields.includes('username') ? 'true' : ''}
                keyProp={55}
                readOnly={isEditing}
              />
              <Input
                labelText='National ID'
                name='nationalId'
                value={state?.nationalId}
                onChange={handleChange}
                placeholder='Enter National ID number'
                invalid={invalidFields.includes('nationalId') ? 'true' : ''}
                keyProp={3}
              />
              <Input
                type='tel'
                name='contact-phoneNumber'
                labelText='Phone number'
                value={state?.contact?.phoneNumber}
                onChange={handleChange}
                disabled={isEditing ? true : false}
                placeholder='Enter phone number'
                invalid={invalidFields.includes('contact-phoneNumber') ? 'true' : ''}
                keyProp={4}
              />
              <Input
                type='tel'
                name='contact-secondaryPhoneNumber'
                labelText='Secondary phone number'
                value={state?.contact?.secondaryPhoneNumber}
                onChange={handleChange}
                placeholder='Enter secondary phone number'
                keyProp={44}
              />
              <Input
                type='email'
                name='contact-email'
                labelText='Email'
                value={state?.contact?.email}
                onChange={handleChange}
                placeholder='Enter email'
                keyProp={5}
              />
              <HonestSelectInput
                disabled={user?.role?.permissions?.contractors}
                onChange={(value: ISelectValue, name: string) => {
                  handleReactSelect(value, name)
                }}
                defaultValue={state?.accessType}
                options={accessTypeList}
                labelText='Access Type'
                name='accessType'
                invalid={invalidFields.includes('accessType')}
              />
              {/* <HonestSelectAsyncInput
                nomarg
                link='roles'
                placeholder='Search role'
                name='role'
                labelText='Role'
                defaultValue={state?.role?.name}
                onChange={(type: ISelectValue, name: string) => handleReactSelect(type, name)}
                parserFunction={parse}
                invalid={invalidFields.includes('role')}
              /> */}
              <HonestSelectAsyncInput
                nomarg
                link='departments'
                placeholder='Search department'
                name='department'
                labelText='Department'
                defaultValue={state?.department?.label}
                onChange={(type: ISelectValue, name: string) => handleReactSelect(type, name)}
                parserFunction={parse}
              />
              <HonestSelectAsyncInput
                nomarg
                link='locations'
                placeholder='Search location'
                name='workplaceLocation'
                labelText='Workplace'
                defaultValue={state?.workplaceLocation?.name}
                onChange={(type: ISelectValue, name: string) => handleReactSelect(type, name)}
                parserFunction={parse}
              />

              <HonestSelectInput
                options={dietaryPreferences}
                name='foodDietaryPreferenceType'
                defaultValue={state?.foodDietaryPreferenceType?.value}
                labelText='Dietary Preference'
                onChange={handleReactSelect}
                nomarg
              />

              <CalendarInput
                labelText='Date of Birth'
                defaultValue={state?.dateOfBirth ? new Date(state.dateOfBirth) : null}
                onChange={handleDateChange}
                name='dateOfBirth'
                maxDate={getDobYears()}
              />
              <HonestSelectAsyncInput
                name='nationality'
                onChange={(value: ISelectValue, name: string) => {
                  handleReactSelect(value, name)
                }}
                defaultValue={state?.nationality}
                fixedList={nationalitiesList}
                link='Nationality'
                labelText='Nationality'
                invalid={invalidFields.includes('nationality')}
              />
              {/* <HonestSelectInput
              name='nationality'
              onChange={(value: ISelectValue, name: string) => {
                handleReactSelect(value, name)
              }}
              defaultValue={state.nationality}
              options={nationalitiesList}
              labelText='Nationality'
              invalid={invalidFields.includes('nationality')}
            /> */}
              <HonestSelectInput
                name='gender'
                onChange={(value: ISelectValue, param: string) => {
                  handleReactSelect(value, param)
                }}
                defaultValue={state?.gender}
                options={genderList}
                labelText='Gender'
                invalid={invalidFields.includes('gender')}
              />
              <HonestSelectInput
                options={educationLevelOptions}
                labelText='Education level'
                name='educationLevel'
                defaultValue={state?.educationLevelType ? state.educationLevelType?.value : null}
                onChange={(value: ISelectValue) => {
                  setState(prev => ({ ...prev, educationLevelType: value }))
                }}
              />
              <HonestSelectInput
                name='maritalStatus'
                onChange={(value: ISelectValue, name: string) => {
                  handleReactSelect(value, name)
                }}
                defaultValue={state?.maritalStatus}
                options={maritalStatus}
                labelText='Marital Status'
                invalid={invalidFields.includes('maritalStatus')}
              />

            </InputContainer>
            <Separator />
            <Flex column width='100%' gap='1rem' >
              <TitleText weight='bold' >Emergency Contact</TitleText>
              <InputContainer>
                <HonestSelectInput
                  options={emergencyContactOptions}
                  labelText='Relative'
                  name='emergencyContact-type'
                  defaultValue={state?.emergencyContact ? state.emergencyContact.type?.value : null}
                  onChange={(value: ISelectValue) => {
                    setState(prev => ({ ...prev, emergencyContact: { ...prev.emergencyContact, type: value } }))
                  }}
                />
                <Input
                  type='tel'
                  name='phoneNumber'
                  labelText='Phone number'
                  value={state?.emergencyContact?.phoneNumber}
                  onChange={handleEmergency}
                  placeholder='Enter phone number'
                  disabled={!state?.emergencyContact?.type?.value}
                />
                <Input
                  name='firstName'
                  labelText='First name'
                  value={state?.emergencyContact?.firstName}
                  onChange={handleEmergency}
                  placeholder='Enter first name'
                  disabled={!state?.emergencyContact?.type?.value}
                />
                <Input
                  name='lastName'
                  labelText='Middle and Last Name'
                  value={state?.emergencyContact?.lastName}
                  onChange={handleEmergency}
                  placeholder='Enter last name'
                  disabled={!state?.emergencyContact?.type?.value}
                />
              </InputContainer>
            </Flex>
            <Separator />
            <Flex column width='100%' gap='1rem' >
              <TitleText weight='bold' >Document</TitleText>
              {singleUser?.documentsFromResponse?.length && <SmallTable>
                <SmallThead>
                  <tr>
                    <th>File Name</th>
                    <th>Category</th>
                    <th>Access Restrictions</th>
                    <th>Effective Date</th>
                    <th>Expiration Date</th>
                    <th>Version</th>
                  </tr>
                </SmallThead>

                <tbody>
                  {
                    singleUser?.documentsFromResponse?.map((d) => {
                      return (
                        <tr key={d.id || '/'} >
                          <td><a href={d.fileUrl}> <BodyText style={{ textDecoration: 'underline' }} >{d.fileName || '/'}</BodyText> </a></td>
                          <td>{documentCategoryOptions.find(o => o.value == d.category)?.label || '/'}</td>
                          <td>{documentAccessRestrictionsOptions.find(r => r.value == d.accessRestrictions)?.label || '/'}</td>
                          <td>{formatDateForDisplay(d.effectiveDate) || '/'}</td>
                          <td>{formatDateForDisplay(d.expiryDate) || '/'}</td>
                          <td>{d.version || '/'}</td>
                        </tr>
                      )
                    })}
                </tbody>
              </SmallTable>}
              <Flex column gap='1rem' >
                <BodyText style={{ marginTop: 30 }} >Import from file</BodyText>
                <DropZone acceptAll file={state.file} setFile={(file: File) => setState(prev => ({ ...prev, file }))} />
              </Flex>
              <ItemsGrid width='100%' columns={2} >
                <HonestSelectInput nomarg name='category' options={documentCategoryOptions} labelText='Category' onChange={handleDocumentSelect} defaultValue={state?.documentData?.category?.value} />
                <HonestSelectInput nomarg name='accessRestrictions' options={documentAccessRestrictionsOptions} labelText='Access Restrictions' onChange={handleDocumentSelect} defaultValue={state?.documentData?.accessRestrictions?.value} />
                <CalendarInput nomarg width='100%' name='effectiveDate' labelText='Effective Date' onChange={handleDocumentDateChange} defaultValue={state?.documentData?.effectiveDate} />
                <CalendarInput nomarg width='100%' name='expiryDate' labelText='Expiration Date' onChange={handleDocumentDateChange} defaultValue={state?.documentData?.expiryDate} />
              </ItemsGrid>
              <Input nomarg type='number' width='100%' name='version' placeholder='Enter version' labelText='Version' value={state?.documentData?.version} onChange={(e) => setState({ ...state, documentData: { ...state.documentData, version: e.target.value } })} />
            </Flex>
          </Flex>

        </Flex>
      </SpecificationWrapper>
      <TabFooter>
        <ButtonsContainer>
          <CancelBtn />
          <Button type='button' onClick={handleSave} orange>
            Save
          </Button>
        </ButtonsContainer>
      </TabFooter>
      {modal && createPortal(<TerminateContractModal id={singleUser?.id} fromUserPage={true} closeModal={() => setModal(false)} />, document.body)}
    </Animation>
  )
}
